import { makeRequest } from "./api";

export const FetchDocuments = async (page, limit) => {
  return makeRequest(
    `/api/admin/document-verification/fetch?page=${page}&limit=${limit}`
  );
};

export const UpdateStatus = async (profileId, status) => {
  return makeRequest(`/api/admin/document-verification/update`, {
    method: "PUT",
    data: { profileId, status },
  });
};

export const SearchDocuments = async (keyword, page, limit) => {
  return makeRequest(
    `/api/admin/document-verification/search?key=${keyword}&page=${page}&limit=${limit}`
  );
};

export const DownloadCSV = async () => {
  return makeRequest("/api/admin/document-verification/download-csv");
};

export const SingleReview = async (reviewId) => {
  return makeRequest(`/api/admin/manage/reviews/single/${reviewId}`);
};

export const ListingStatusUpdate = async (reviewId, description, rating) => {
  return makeRequest("/api/admin/manage/reviews/update", {
    method: "PUT",
    data: { reviewId, description, rating },
  });
};

export const UpdateReview = async (reviewId, description, rating) => {
  return makeRequest(`/api/admin/manage/reviews/update`, {
    method: "PUT",
    data: { reviewId, description, rating },
  });
};

export const WriteReview = async (propertyId, description, rating) => {
  return makeRequest(`/api/admin/manage/reviews/write`, {
    method: "POST",
    data: { propertyId, description, rating },
  });
};
